angular.module("impactx.warnings").service("WarningService", WarningService);

WarningService.$inject = ["$mdDialog"];

function WarningService($mdDialog) {
  return {
    showWarningDialog: function (
      callBackFunction,
      event,
      warningLabel,
      saveLabel,
      abortLabel,
      warnings,
      callBackParam,
      saveDisabled,
      abortFunction
    ) {
      return $mdDialog
        .show({
          controller: "WarningsCtrl",
          controllerAs: "warningsCtrl",
          templateUrl: "shared/warnings/templates/warnings.tmpl.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            warnings: warnings,
            saveLabel: saveLabel,
            abortLabel: abortLabel,
            warningLabel: warningLabel,
            saveDisabled: saveDisabled,
          },
        })
        .then(
          function () {
            if (callBackParam) {
              return callBackFunction(callBackParam);
            } else {
              return callBackFunction();
            }
          },
          function () {
              if (abortFunction) {
                  abortFunction();
              }
          }
        );
    },
    showWarningDialogNoCallback: function (
      event,
      warningLabel,
      saveLabel,
      abortLabel,
      warnings,
      saveDisabled
    ) {
      return $mdDialog.show({
          controller: "WarningsCtrl",
          controllerAs: "warningsCtrl",
          templateUrl: "shared/warnings/templates/warnings.tmpl.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            warnings: warnings,
            saveLabel: saveLabel,
            abortLabel: abortLabel,
            warningLabel: warningLabel,
            saveDisabled: saveDisabled,
          },
        });
    },
    /**
     * Neu erstellt bei Migration zu Angular um gleich auch diesen
     * Dialog zu testen.
     * Nutzung wäre in:
     * - ix.invoice-view-controller.js
     * - ix.pat-dialog.controller.js
     *
     * @param {*} callBackFunction
     * @param {*} event
     * @param {*} warningLabel
     * @param {*} saveLabel
     * @param {*} abortLabel
     * @param {*} warnings
     */
    showConfirmSingleWarningsDialog: function (
      callBackFunction,
      event,
      warningLabel,
      proceedLabel,
      abortLabel,
      warningList
    ) {
      $mdDialog
        .show({
          controller: "ConfirmSingleWarningsCtrl",
          controllerAs: "warningsCtrl",
          templateUrl:
            "shared/warnings/templates/confirm-single-warnings.tmpl.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            warningList: warningList,
            proceedLabel: proceedLabel,
            abortLabel: abortLabel,
            warningLabel: warningLabel,
          },
        })
        .then(
          function () {
            callBackFunction();
          },
          function () {}
        );
    },
  };
}
